var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EpicIcon",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Epic",
    d: "M14.67,16H1.33A1.34,1.34,0,0,1,0,14.67V1.33A1.34,1.34,0,0,1,1.33,0H14.67A1.34,1.34,0,0,1,16,1.33V14.67A1.34,1.34,0,0,1,14.67,16ZM12.49,4h-4A.57.57,0,0,0,8,4.61v7.78a.57.57,0,0,0,.51.61h4a.57.57,0,0,0,.51-.61V4.61A.57.57,0,0,0,12.49,4ZM11.33,7H9.67V6h1.66ZM6.53,3H3.47A.54.54,0,0,0,3,3.59v8.82a.54.54,0,0,0,.47.59H6.53A.54.54,0,0,0,7,12.41V3.59A.54.54,0,0,0,6.53,3ZM5.6,6H4.4V5H5.6Z",
    fill: "#800080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicIcon);
export default __webpack_public_path__ + "static/media/EpicIcon.45c8c8a36b6ec3dd2bec3af608c92e8e.svg";
export { ForwardRef as ReactComponent };